import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const CATEGORY_API_PATH = '/api/categories';

const fetchCategories = async () => {
  const response = await axios.get(`${API_BASE_URL}${CATEGORY_API_PATH}`);
  return response.data.data;
};

const createCategory = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}${CATEGORY_API_PATH}`, payload);
  return response.data.data;
};

const updateCategory = async (id, payload) => {
  const response = await axios.put(`${API_BASE_URL}${CATEGORY_API_PATH}/${id}`, payload);
  return response.data.data;
};

const deleteCategory = async (id) => {
  await axios.delete(`${API_BASE_URL}${CATEGORY_API_PATH}/${id}`);
};

const categoryService = {
  fetchCategories,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default categoryService;
